import React, { useEffect, useState } from 'react';
import { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { LockIcon } from 'lucide-react';
import { toast } from 'sonner';
import { getActiveSession, isAdminSession, signInWithPassword, signOut } from '../../data/supabase';
import { getSupabaseErrorMessage } from '../../data/repository';
export function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    void getActiveSession().then(session => {
      if (isAdminSession(session)) navigate('/admin/dashboard', {
        replace: true
      });
    });
  }, [navigate]);
  const handleLogin = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const session = await signInWithPassword(email.trim(), password);
      if (!isAdminSession(session)) {
        await signOut();
        throw new Error('Ovaj Supabase račun nema administratorska dopuštenja.');
      }
      toast.success('Prijava uspješna');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(getSupabaseErrorMessage(error));
      setPassword('');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-418" data-mp="2alk9tw7p9ove">
      <div className="w-full max-w-sm rounded-3xl border border-gray-100 bg-white p-8 shadow-lg" data-id="element-419" data-mp="1d1h8r35dutis">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-900 text-white" data-id="element-420" data-mp="1hzinxczou8oz">
          <LockIcon size={30} data-id="element-421" data-mp="1mvze0cqg6x4p" />
        </span>
        <h1 className="mt-6 text-center text-2xl font-black text-gray-900" data-id="element-422" data-mp="1rpakgcrclbw3">
          Admin prijava
        </h1>
        <p className="mt-2 text-center text-sm text-gray-500" data-id="element-423" data-mp="u8dbz8wvc0jy">
          Prijavite se Supabase administratorskim računom.
        </p>
        <form onSubmit={handleLogin} className="mt-7 space-y-4" data-id="element-424" data-mp="z6n9vr9z9f99">
          <label className="block text-sm font-bold text-gray-700" data-id="element-425" data-mp="r6qo9vegs6kf">
            Email
            <input type="email" required value={email} onChange={event => setEmail(event.target.value)} autoComplete="email" className="mt-1 w-full rounded-xl border border-gray-200 p-3" data-id="element-426" data-mp="n701s3vz0clp" />
          </label>
          <label className="block text-sm font-bold text-gray-700" data-id="element-427" data-mp="8861gfjlvncl">
            Lozinka
            <input type="password" required value={password} onChange={event => setPassword(event.target.value)} autoComplete="current-password" className="mt-1 w-full rounded-xl border border-gray-200 p-3" data-id="element-428" data-mp="47ue2uzuz8xf" />
          </label>
          <button disabled={isSubmitting} className="w-full rounded-xl bg-gray-900 py-3 font-bold text-white hover:bg-gray-800 disabled:opacity-60" data-id="element-429" data-mp="1tkza75msmfto">
            {isSubmitting ? 'Prijava…' : 'Prijavi se'}
          </button>
        </form>
      </div>
    </div>;
}